<template>
    <modal @close="close" class="fluid" dialog="modal-sm" :footer="false">
        <div slot="title">
            Send message
        </div>

        <div slot="body">
            <form class="wrapper fs-normal" action="" @submit.prevent="send">
                <div class="form-row mb-3">
                    <v-select label="name" placeholder="Select or search for an agent" v-model="message.to" :options="agents"></v-select>
                </div>

                <div class="form-row">
                    <textarea v-model="message.text" placeholder="Write your message here ..."></textarea>    
                </div>

                <div class="d-flex">
                    <input type="submit" class="btn action wider ml-auto" value="Send">
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Modal from './Modal'

    export default {
        data: function() {
            return {
                message: {
                    from: null,
                    to: null,
                    text: '',
                }
            }
        },
        created: function() {
            this.resetForm();
        },
        computed: {
            ...mapGetters([
                'getAgents',
            ]),
            agents: function() {
                return this.getAgents;
            }
        },
        methods: {
            ...mapActions([
                'sendMessage',
            ]),
            close: function() {
                this.resetForm();
            },
            send: function() {
                this.sendMessage(this.message);
            },
            resetForm: function() {
                this.message.from = 'Pluralo Team';
                this.message.to = null;
                this.message.text = '';
            }
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
        }
    }
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// AgentNewMessage.vue?7f591691